import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

/**
 * Input.
 *
 * Tight neutral box with subtle border. Focus ring uses the
 * Theia orange (consistent with our focus-visible policy
 * elsewhere). Smaller than shadcn's default — 28 px tall matches
 * our `Button size="sm"` so form rows align cleanly.
 */
export const Input = forwardRef<
  HTMLInputElement,
  InputHTMLAttributes<HTMLInputElement>
>(({ className, type, ...props }, ref) => (
  <input
    type={type}
    ref={ref}
    className={cn(
      'flex h-7 w-full rounded-sm border border-input bg-neutral-950 px-2 py-1 text-xs',
      'text-foreground placeholder:text-muted-foreground',
      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:border-neutral-700',
      'disabled:cursor-not-allowed disabled:opacity-50',
      'file:border-0 file:bg-transparent file:text-sm file:font-medium',
      className,
    )}
    {...props}
  />
));
Input.displayName = 'Input';
